import { DASHBOARD_ACTIVITY_LINK } from '@components/Router/constants'
import { Bell } from '@octopus-do/octopus-storybook/icons'
import { selectUnreadCount } from '@store/reducers/inbox'
import type React from 'react'
import { useSelector } from 'react-redux'

import { SidebarLink } from '../SidebarLink'

interface Props {
  workspaceId: string
}

// A sidebar row like Members, leading to the workspace's activity page; the
// dot on the right means there is something unread there
export const ActivityLink: React.FC<Props> = ({ workspaceId }) => {
  const unread = useSelector(selectUnreadCount(workspaceId))

  return (
    <SidebarLink
      to={`${DASHBOARD_ACTIVITY_LINK}/${workspaceId}`}
      label="Activity"
      icon={Bell}
      unread={unread > 0}
      testId="activity_link"
    />
  )
}
